import { Button, Typography } from "antd";
import { Link, useLocation } from "react-router";
import GlassPanel from "../../components/common/glassPanel";
import { getSector } from "../../data/admin";

const { Text, Title } = Typography;

export default function SectorHomeScreen() {
  const location = useLocation();
  const sectorKey = location.pathname.split("/")[1];
  const sector = getSector(sectorKey);

  return (
    <div className="space-y-4 px-1 py-1">
      <GlassPanel eyebrow="Sector Shell" title={sector.label}>
        <Text type="secondary">
          This vertical is using the shared employee shell. Add product-specific modules under `src/screens/{sector.key}` when the workflow becomes domain-specific.
        </Text>
        <div className="mt-4">
          <Link to="/overview">
            <Button type="primary">Back to company overview</Button>
          </Link>
        </div>
      </GlassPanel>

      <GlassPanel title="Current State">
        <Title level={4} className="mb-1! mt-0!">Shared foundation ready</Title>
        <Text type="secondary">
          Navigation, layout, theme, and common internal routes are in place. Sector screens for {sector.shortLabel} have not been specialized yet.
        </Text>
      </GlassPanel>
    </div>
  );
}
